import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();


export const getBatchEmployeeApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/BatchEmployee/GetAllBatchEmployee`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
 
export const updateBatchEmployeeApi = async (
    url: string,
    data: {
        id: string,
        batchId?: string,
        employeeId?: string,
        hourlyRate?: number,
        startTime?: string,
        endTime?: string,
        startDate?: string,
        endDate?: string,
        salary?: number,
        status?: string
    }
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.put(
            `${url}/BatchEmployee/Update`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error;
    }
}


export const deleteBatchEmployeeApi = async (id: string, url: string) => {
    const token = cookies.get('authToken');

    try {

        const response = await axios.request({
            method: "DELETE",
            url: `${url}/BatchEmployee/Delete`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: {
                id,
            },
        });
        return response.data;

    } catch (error) {
        console.error(error)
        throw error;
    }
}

export const addBatchEmployeeApi = async (
    url: string,
    batchId: string,
    employeeId: string,
    hourlyRate: number,
    startTime: string,
    endTime: string,
    startDate: string,
    endDate?: string
) => {
    const token = cookies.get("authToken");
    try {
        const response = await axios.post(
            `${url}/BatchEmployee/Create`,
            {
                batchId,
                employeeId,
                hourlyRate,
                startTime,
                endTime,
                startDate,
                endDate
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getBatchEmployeesByBatchIdApi = async (
    url: string,
    batchId: string,
    searchTerm: string = "",
    pageNumber: number = 1,
    pageSize: number = 10
) => {
    const token = cookies.get("authToken");
    try {
        const response = await axios.get(
            `${url}/BatchEmployee/GetByBatchId/${batchId}`,
            {
                params: {
                    searchTerm,
                    pageNumber,
                    pageSize,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};